import { createFeatureSelector, createSelector } from '@ngrx/store';
import { siteFeatureKey, SiteState } from './site.reducer';

export const getSiteState = createFeatureSelector<SiteState>(siteFeatureKey);

export const getSiteListByCity = createSelector(getSiteState, state => state.siteList);
